'use client'

import { type ReactNode } from 'react'

import { cn } from '@src/utils/tailwind'

export const AlignItems = ['strech', 'center', 'start', 'end'] as const
export const JustifyContent = ['center', 'start', 'end', 'around', 'evenly', 'between'] as const

interface FlexProps {
  isColumn?: boolean
  reverseInMobile?: boolean
  alignItems: (typeof AlignItems)[number]
  justifyContent: (typeof JustifyContent)[number]
  gap?: number
  flexWrap?: boolean
  children: ReactNode
}

export const Flex = (props: FlexProps) => {
  const {
    isColumn,
    alignItems,
    justifyContent,
    reverseInMobile,
    gap,
    flexWrap = false,
    children,
  } = props
  return (
    <div
      className={cn('flex flex-row', {
        'flex-col': isColumn,
        'flex-row lg:flex-col': reverseInMobile && isColumn,
        'flex-col lg:flex-row': reverseInMobile && !isColumn,
        'items-center': alignItems === 'center',
        'items-end': alignItems === 'end',
        'items-stretch': alignItems === 'strech',
        'items-start': alignItems === 'start',
        'justify-center': justifyContent === 'center',
        'justify-end': justifyContent === 'end',
        'justify-start': justifyContent === 'start',
        'justify-around': justifyContent === 'around',
        'justify-evenly': justifyContent === 'evenly',
        'justify-between': justifyContent === 'between',
        'flex-wrap': flexWrap,
      })}
      style={{
        gap,
      }}
    >
      {children}
    </div>
  )
}
